import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor, getMALabel } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class MADeviationTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      displayFormat,
      className,
      yAccessor,
      options,
      labelFill,
      textFill,
    } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let value = "n/a";
    let color = textFill;

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      if (isDefined(item) && isDefined(item.value)) {
        value = displayFormat(item.value);
        // Use green/red based on direction
        color = item.direction === "up" ? "#00DD00" : "#FF0000";
      }
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const { windowSize, maType, mode, sourcePath } = options || {};

    // Map sourcePath to display label
    const fieldLabel =
      {
        close: "Close",
        open: "Open",
        high: "High",
        low: "Low",
      }[sourcePath] ||
      sourcePath ||
      "Close";

    // Get MA type label from centralized utility
    const maTypeLabel = getMALabel(maType);

    const modeLabel = mode === "Percent" ? "%" : "Pts";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-madeviation"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>
            {`Desvio MA (${windowSize ?? "?"}, ${fieldLabel}, ${maTypeLabel}, ${modeLabel}): `}
          </ToolTipTSpanLabel>
          <tspan fill={color}>{value}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

MADeviationTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  options: PropTypes.shape({
    windowSize: PropTypes.number,
    sourcePath: PropTypes.string,
    maType: PropTypes.string,
    mode: PropTypes.string,
  }),
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

MADeviationTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip react-stockcharts-ma-deviation-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default MADeviationTooltip;
